import { css } from "styled-components";
import {
  PRIMARY_BUTTON_BG,
  PRIMARY_COLOR,
  PRIMARY_LABEL_COLOR,
  SECONDARY_COLOR,
  SECONDARY_BUTTON_BG
} from "../constants/color";

export const FormCommonStyle = css`
  font-size: 14px;
  input {
    font-size: 14px;
  }
  label {
    color: ${PRIMARY_LABEL_COLOR};
  }
`;

export const PrimaryButton = css`
    background: ${PRIMARY_BUTTON_BG};
    color: ${SECONDARY_COLOR}
    &:hover {
        background: ${PRIMARY_BUTTON_BG};
    }
`;

export const PrimayBackground = css`
  background: ${PRIMARY_COLOR};
  background-color: ${PRIMARY_COLOR};
`;

export const PrimayColor = css`
  color: ${SECONDARY_COLOR};
`;

export const SecondaryBackground = css`
  background: ${SECONDARY_COLOR};
  background-color: ${SECONDARY_COLOR};
`;

export const SecondaryColor = css`
  color: ${PRIMARY_COLOR};
`;

export const SecondaryButton = css`
    background: ${SECONDARY_BUTTON_BG};
    color: ${SECONDARY_COLOR}
    &:hover {
        background: ${SECONDARY_BUTTON_BG};
    }
`;